// Utilitaires couleur pour les tags patients : fond teinté + texte lisible (contraste auto).
function hexToRgb(hex) {
  if (!hex) return { r: 148, g: 163, b: 184 };
  let h = hex.replace("#", "").trim();
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const n = parseInt(h, 16);
  if (Number.isNaN(n) || h.length !== 6) return { r: 148, g: 163, b: 184 };
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

// Luminance relative (WCAG).
function luminance({ r, g, b }) {
  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}

// Pastille de tag : fond doux teinté + bordure de la couleur + texte foncé lisible.
export function tagChipStyle(hex) {
  const { r, g, b } = hexToRgb(hex);
  const lum = luminance({ r, g, b });
  const bg = `rgba(${r}, ${g}, ${b}, 0.16)`;
  const border = `rgba(${r}, ${g}, ${b}, 0.55)`;
  const darken = (c) => Math.round(c * 0.5);
  // Sur fond clair, on garde une couleur suffisamment foncée pour la lecture.
  const text = lum > 0.5 ? `rgb(${darken(r)}, ${darken(g)}, ${darken(b)})` : `rgb(${r}, ${g}, ${b})`;
  return { background: bg, color: text, border: `1px solid ${border}` };
}

// Variante pleine : fond = couleur solide, texte blanc/noir selon contraste.
export function tagSolidStyle(hex) {
  const rgb = hexToRgb(hex);
  const text = luminance(rgb) > 0.55 ? "#1a1a1a" : "#ffffff";
  return { background: `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`, color: text, border: "1px solid rgba(0,0,0,0.08)" };
}
